"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useLayoutEffect, useState } from "react";

export function ExploreThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useLayoutEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <button
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-none bg-[var(--explore-bg)] text-[var(--explore-text-muted)] transition-colors hover:bg-[var(--explore-tag-bg)] hover:text-[var(--explore-text-primary)]"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      type="button"
    >
      {mounted ? (
        isDark ? (
          <Sun className="h-[18px] w-[18px]" />
        ) : (
          <Moon className="h-[18px] w-[18px]" />
        )
      ) : (
        <div className="h-[18px] w-[18px]" />
      )}
    </button>
  );
}
